import { UserManager, UserManagerSettings } from "oidc-client-ts";

import { authConfig } from "./oidc-config";

/** Lead time on the `accessTokenExpiring` event, and the window `refreshAccessToken` treats as due for renewal. */
export const accessTokenExpiringLeewaySeconds = 60;

let instance: UserManager | undefined;

/**
 * Shared UserManager: the single owner of the OIDC session. AuthProvider and the
 * token-refresh path both use this instance so storage, the in-memory user, and
 * auth events cannot diverge.
 */
export function getUserManager(): UserManager {
  instance = instance ?? new UserManager(toUserManagerSettings());
  return instance;
}

function toUserManagerSettings(): UserManagerSettings {
  const { authority, client_id, redirect_uri } = authConfig;
  if (!authority || !client_id || !redirect_uri) {
    throw new Error("Auth configuration is incomplete: authority, client_id and redirect_uri are required.");
  }
  return {
    ...authConfig,
    authority,
    client_id,
    redirect_uri,
    accessTokenExpiringNotificationTimeInSeconds: accessTokenExpiringLeewaySeconds,
    // Per-tab renew timers would race each other over single-use rotating refresh
    // tokens; refreshAccessToken serializes renewal behind a Web Lock instead.
    automaticSilentRenew: false,
  };
}
